import mediaUrl from "../../utils/mediaUrl";
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import Footer from "../Footer";
import Header from "../Header";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import "../../assets/css/courses.css";
import axios from "axios";
import auth from "../../utils/auth";
import { IonPage } from "@ionic/react";

const Courses = (props) => {
	const [isOpaque, setIsOpaque] = useState(true);
	const [courses, setCourses] = useState([]);
	const [allCourses, setAllCourses] = useState([]);
	const [categories, setCategories] = useState([]);
	const [currentTab, setCurrentTab] = useState("");
	const filterTrackRef = useRef(null);

	const scrollFilter = (direction) => {
		filterTrackRef.current?.scrollBy({
			left: direction * 280,
			behavior: "smooth",
		});
	};

	const isActive = (tabName) => {
		return currentTab == tabName ? "active" : "";
	};

	const handleTab = (categoryId) => {
		setCourses(
			categoryId
				? allCourses.filter((c) => String(c.category) === String(categoryId))
				: allCourses
		);
		setCurrentTab(categoryId);
	};

	const handleSearch = (e) => {
		// console.log(e.target.value) ;
		setCourses(
			allCourses.filter((c) => {
				return c.name.toLowerCase().includes(e.target.value.toLowerCase());
			})
		);
	};

	useEffect(() => {
		const config = {
			headers: {
				"Content-Type": "application/json",
				"x-auth-token": auth.getToken(),
			},
		};

		axios
			.get(`/courses`, config)
			.then((res) => {
				// Public site shows published + coming-soon; drafts stay hidden.
				const visible = res.data.courses.filter((c) => c.status !== "draft");
				setCourses(visible);
				setAllCourses(visible);
			})
			.catch((err) => console.log(err));

		axios
			.get(`/categories`)
			.then((res) => setCategories(res.data.categories))
			.catch((err) => console.log(err));

		window.addEventListener("scroll", (e) => {
			if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
				setIsOpaque(false);
			} else {
				setIsOpaque(true);
			}
		});

		return () => {
			window.removeEventListener("scroll", (e) => {
				if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
					setIsOpaque(false);
				} else {
					setIsOpaque(true);
				}
			});
		};
	}, []);

	return (
		<IonPage>
			<div id="header_place">
				<Header isOpaque={isOpaque} />
			</div>
			<section id="hero_area2">
				<div className="center_wrapper">
					<div>
						<h1>Our Courses</h1>
					</div>
					<div className="search_box on_blue">
						<input
							onChange={(e) => handleSearch(e)}
							placeholder="Search for course"
							id="search"
						/>
						<svg
							className="search_icon"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							aria-hidden="true"
						>
							<circle cx="10.5" cy="10.5" r="6.75" stroke="currentColor" strokeWidth="1.8" />
							<line x1="15.6" y1="15.8" x2="20.3" y2="20.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
						</svg>
					</div>
				</div>
			</section>

			<section id="our_courses2">
				<div className="center_wrapper">
					<div className="course_filter">
						<button
							type="button"
							className="filter_arrow"
							aria-label="Scroll categories left"
							onClick={() => scrollFilter(-1)}
						>
							<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
								<polyline
									points="14.5,6 9.5,12 14.5,18"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</button>
						<div className="filter_track" ref={filterTrackRef}>
							<div
								className={isActive("") + " tab"}
								onClick={() => handleTab("")}
							>
								All
							</div>
							{categories.map((cat) => (
								<div
									key={cat._id}
									className={isActive(cat._id) + " tab"}
									onClick={() => handleTab(cat._id)}
								>
									{cat.name}
								</div>
							))}
						</div>
						<button
							type="button"
							className="filter_arrow"
							aria-label="Scroll categories right"
							onClick={() => scrollFilter(1)}
						>
							<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
								<polyline
									points="9.5,6 14.5,12 9.5,18"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</button>
					</div>
					<br />
					<br />
					<div className="courses_cards courses_cards2">
						{courses.map((course) => (
							<div key={course._id} className="course">
								<img
									className="course_image"
									src={mediaUrl(course.thumbnail)}
									alt={course.name}
								/>
								<div className="course_title">{course.name}</div>
								<div className="course_description">{course.description}</div>
								<div className="course_attributes">
									<div className="time">
										<svg
											className="time_icon"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											aria-hidden="true"
										>
											<circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
											<path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
										</svg>
										{course.duration || "15 Min."}
									</div>
									<div className="inr">
										{course.currency || "INR"} {course.price}/-
									</div>
								</div>
								{course.status === "comingSoon" ? (
									<button type="button" className="know_more coming_soon" disabled>
										Coming Soon
									</button>
								) : (
									<Link to={`/courses/${course._id}`} className="know_more">
										Know More
									</Link>
								)}
							</div>
						))}
						{courses.length === 0 && (
							<div className="course_description" style={{ padding: 20 }}>
								No courses found.
							</div>
						)}
					</div>
				</div>
			</section>

			<div id="footer_place">
				<Footer />
			</div>
		</IonPage>
	);
};

export default Courses;
